import ServerRequestUtil from '../utils/ServerRequestUtil';

export default new class {

    async getForthingDetail() {
        return ServerRequestUtil.get('/api/app/token/forthing/detail');
    }

    async getForthingTransactions(data) {
        return ServerRequestUtil.get('/api/app/token/forthing/transactions', {...data});
    }

    async getForthingLatestTransactions() {
        return ServerRequestUtil.get('/api/app/token/forthing/transactions/latest');
    }

    async getExBonusTransactions(data) {
        return ServerRequestUtil.get('/api/app/token/exbonus/transactions', {...data});
    }

    async getWallet() {
        return ServerRequestUtil.get('/api/app/token/wallet/detail');
    }

    async getWalletTransactions(data) {
        return ServerRequestUtil.get('/api/app/token/wallet/transactions', {...data});
    }

    async getWalletLatestTransactions() {
        return ServerRequestUtil.get('/api/app/token/wallet/transactions/latest');
    }

    async getTransactions(data) {
        return ServerRequestUtil.get("/api/app/token/transactions", {...data});
    }

    async transferTransaction(data) {
        return ServerRequestUtil.post("/api/app/token/wallet/transfer-transaction", data);
    }

    async transferTransactionNoVerify(data) {
        return ServerRequestUtil.post("/api/app/token/wallet/transfer-transaction-v2", data);
    }

    async sendVerificationTransaction(data) {
        return ServerRequestUtil.put("/api/app/token/wallet/verify-transaction", data);
    }

    async requestResendVerifyCode(data) {
        return ServerRequestUtil.put("/api/app/token/wallet/resend-verify-code", data);
    }

    async cancelTransaction(data) {
        return ServerRequestUtil.put("/api/app/token/wallet/cancel-transaction", {...data});
    }

    async validateWithdrawal(data) {
        return ServerRequestUtil.post("/api/app/token/withdrawal/validate", data);
    }

    async sendWithdrawalConfirmEmail(data) {
        return ServerRequestUtil.post("/api/app/token/withdrawal/sendEmail", data);
    }

    async confirmWithdrawal(token) {
        return ServerRequestUtil.post("/api/app/token/withdrawal/confirm", {token});
    }

    async getHecDataHistoryListExport(params) {
        return ServerRequestUtil.get("/api/app/token/historyListCSV", {...params});
    }
}
